export function looksLikeHtml(value: string): boolean {
  return /<\/?[a-z][\s\S]*>/i.test(value ?? "");
}

export function escapeHtml(value: string): string {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

/** Strip HTML tags for search, previews, and empty checks. */
export function stripHtmlToPlain(html: string): string {
  if (!html || typeof html !== "string") return "";
  return html
    .replace(/<[^>]+>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function isRichTextEmpty(html: string): boolean {
  return stripHtmlToPlain(html).length === 0;
}

/**
 * The composer shows a blank line as an empty paragraph. Outside the editor
 * that `<p></p>` has no height, so the gap disappears. Give it a break so the
 * published post keeps the same spacing.
 */
export function preserveEmptyParagraphs(html: string): string {
  if (!html || !html.includes("<p")) return html;
  return html.replace(/<p(\s[^>]*)?>(?:\s|&nbsp;|<br\s*\/?>)*<\/p>/gi, "<p$1><br></p>");
}
